import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { createElement } from "./../utils/create-elements"
import { Form, transformLinkUri } from "gatsby-theme-gba"
import Markdown from "react-markdown"

const FormEditable = ({ blok }) => (
  <div {...storyblokEditable(blok)} key={blok._uid}>
    <Form
      formName={blok.formName}
      heading={blok.heading}
      subHeading={blok.subHeading}
      buttonText={blok.buttonText}
      successHeading={blok.successHeading}
      redirectAfterSubmit={blok.redirectAfterSubmit}
      successMessage={
        <Markdown
          transformLinkUri={(uri) => {
            return transformLinkUri(uri, "", blok.currentLanguage)
          }}
        >
          {blok.successMessage}
        </Markdown>
      }
      successBtnText={blok.successBtnText || "Weiter"}
      authenticationRequired={blok.authenticationRequired}
      currentLanguage={blok.currentLanguage}
      anchorName={blok.anchorName}
      captchaRequired={blok.captchaRequired}
    >
      {createElement(blok, blok.formElements)}
    </Form>
  </div>
)

export default FormEditable
